export const loadState = (key, defaultValue) => {
  try {
    let path = process.env.PUBLIC_URL;
    const serializedState = sessionStorage.getItem(path + key);
    if (serializedState === null) {
      return defaultValue;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return defaultValue;
  }
}

export const saveState = (key, obj) => {
  try {
    let path = process.env.PUBLIC_URL;
    sessionStorage.setItem(path + key, JSON.stringify(obj))
  } catch (error) {

  }
}
